import actionType from 'utils/mw/actionType.util';

const salonUpdateActionType = actionType('salonUpdate');

// noinspection JSUnusedGlobalSymbols
export default salonUpdateActionType;
